import producer from 'immer';
import { Reducer } from 'redux';
import { CriacaoAssuntoState, CriacaoAssuntoTypes } from './types';

const INITIAL_STATE: CriacaoAssuntoState = {
  data: [],
  tempData: [],
  loading: false,
  error: false,
};

const reducer: Reducer<CriacaoAssuntoState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case CriacaoAssuntoTypes.GET_ASSUNTOS_SUCCESS:
      return producer(state, draft => {
        draft.data = action.payload.data;
      });
    case CriacaoAssuntoTypes.CHANGE_STATE_ASSUNTOS_SUCCESS:
      return producer(state, draft => {
        draft.tempData = action.payload.data;
      });

    default:
      return state;
  }
};

export default reducer;
